<template>
  <v-flex xs12 style="position: relative; background-color: #E5E8EB !important">
    <v-container fluid style="padding: 100px 5%">
      <v-layout row style="position: relative">
        <v-flex style="width: 280px !important; flex: none; position: absolute; top: 0; left: 0">
          <v-card class="d-inline-block elevation-0 organizationsMenu" style="width: 100%;background-color: transparent !important">
            <v-navigation-drawer floating permanent stateless value="true" style="background-color: transparent !important">
              <v-list dense>
                <v-list-tile :to="{ path: '/organization/users' }" :class="this.$route.path.includes('users') ? 'menuBorderClass' : 'menuNoBorderClass'">
                  <v-list-tile-content><v-list-tile-title class="primary--text">Organization Users</v-list-tile-title></v-list-tile-content>
                </v-list-tile>

                <v-list-tile :to="{ path: '/organization/payment-history' }" :class="this.$route.path.includes('payment-history') ? 'menuBorderClass' : 'menuNoBorderClass'">
                  <v-list-tile-content><v-list-tile-title class="primary--text">Payment History</v-list-tile-title></v-list-tile-content>
                </v-list-tile>

                <v-list-tile :to="{ path: '/organization/payment-method' }" :class="this.$route.path.includes('payment-method') ? 'menuBorderClass' : 'menuNoBorderClass'">
                  <v-list-tile-content><v-list-tile-title class="primary--text">Payment Methods</v-list-tile-title></v-list-tile-content>
                </v-list-tile>

                <v-list-tile :to="{ path: '/organization/requests' }" :class="this.$route.path.includes('requests') ? 'menuBorderClass' : 'menuNoBorderClass'">
                  <v-list-tile-content><v-list-tile-title class="primary--text">
                    <v-layout>
                      <div>Requests</div>
                      <div style="background-color: #213EFF; color: white; border-radius: 100%; font-size: 14px; font-weight: 700; width: 24px; height: 24px; margin-left: 10px; display: flex; align-items: center; justify-content: center"> {{ requestsCount }}</div>
                    </v-layout>
                  </v-list-tile-title></v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-navigation-drawer>
          </v-card>
        </v-flex>
        <v-flex style="padding-left: 280px; width: 100%">
          <router-view></router-view>
        </v-flex>
      </v-layout>
    </v-container>
  </v-flex>
</template>

<style>
  .organizationsMenu .v-list__tile__title{
    font-size: 18px;
    font-weight: 700;
  }
  .menuBorderClass{
    border-left: 2px solid #011E41;
  }
  .menuNoBorderClass{
    border-left: 2px solid transparent;
  }
  .organizationsMenu a:hover{
    background-color: transparent !important;
  }
</style>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {}
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'currentUser']),
    ...mapGetters({
      userOrganization: 'getUserOrganization'
    }),
    requestsCount () {
      if (!this.userOrganization || !this.userOrganization.organizationProjects || !this.userOrganization.organizationUserProjects) {
        return 0
      }
      var i = 0
      var j = 0
      var accessRequests = []
      var tempaccessRequests = this.userOrganization.organizationUserProjects.filter(item => {
        return !item.status.toLowerCase().includes('active') && !item.status.toLowerCase().includes('user') && !item.status.toLowerCase().includes('external') && Number(item.userId) !== Number(this.currentUser.id)
      })
      for (i = 0; i < tempaccessRequests.length; i++) {
        for (j = 0; j < this.userOrganization.organizationProjects.length; j++) {
          if (Number(tempaccessRequests[i].projectId) === Number(this.userOrganization.organizationProjects[j].projectId) && this.userOrganization.organizationProjects[j].status.toLowerCase().includes('active')) {
            accessRequests.push(tempaccessRequests[i])
            break
          }
        }
      }

      var subscriptionRequests = []
      var tempSubscriptionRequests = this.userOrganization.organizationUserProjects.filter(item => {
        return !item.status.toLowerCase().includes('active') && !item.status.toLowerCase().includes('external') && Number(item.userId) !== Number(this.currentUser.id)
      })
      for (i = 0; i < tempSubscriptionRequests.length; i++) {
        for (j = 0; j < this.userOrganization.organizationProjects.length; j++) {
          if (Number(tempSubscriptionRequests[i].projectId) === Number(this.userOrganization.organizationProjects[j].projectId) && this.userOrganization.organizationProjects[j].type.toLowerCase() === 'subscription' && !this.userOrganization.organizationProjects[j].status.toLowerCase().includes('active')) {
            subscriptionRequests.push(tempSubscriptionRequests[i])
            break
          }
        }
      }

      var projectRequests = []
      var tempProjectRequests = this.userOrganization.organizationUserProjects.filter(item => {
        return !item.status.toLowerCase().includes('active') && !item.status.toLowerCase().includes('external') && Number(item.userId) !== Number(this.currentUser.id)
      })
      for (i = 0; i < tempProjectRequests.length; i++) {
        for (j = 0; j < this.userOrganization.organizationProjects.length; j++) {
          if (Number(tempProjectRequests[i].projectId) === Number(this.userOrganization.organizationProjects[j].projectId) && this.userOrganization.organizationProjects[j].type.toLowerCase() === 'diy' && !this.userOrganization.organizationProjects[j].status.toLowerCase().includes('active') && this.userOrganization.users.find(user => { return Number(user.id) === Number(tempProjectRequests[i].userId) }).active) {
            projectRequests.push(tempProjectRequests[i])
            break
          }
        }
      }

      return accessRequests.length + subscriptionRequests.length + projectRequests.length
    }
  },
  mounted () {
    if (!this.isLoggedIn) {
      this.$router.push({ path: '/' })
    } else if (this.$route.fullPath === '/organization') {
      this.$router.push({ path: '/organization/reports' })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/organization/Organization.vue